import { log } from '@/utils/request';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { Severity } from '@treyd-io/core/constants/logging';

import { AxiosError, AxiosResponse } from 'axios';

import React from 'react';

export const ReactQueryProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error) => {
            const errorResponse = error as AxiosError;
            const status = errorResponse.response?.status;
            if (status === 404 || status === 401) {
              return log({
                res: errorResponse.response as AxiosResponse<unknown>,
                severity: Severity.WARNING,
                options: {},
              });
            }
            log({
              res: errorResponse.response as AxiosResponse<unknown>,
              severity: Severity.ERROR,
              options: {},
            });
          },
        }),
        mutationCache: new MutationCache({
          onError: (error) => {
            const errorResponse = error as AxiosError;
            const status = errorResponse.response?.status;
            if (status === 404 || status === 401) {
              return log({
                res: errorResponse.response as AxiosResponse<unknown>,
                severity: Severity.WARNING,
                options: {},
              });
            }
            log({
              res: errorResponse.response as AxiosResponse<unknown>,
              severity: Severity.ERROR,
              options: {},
            });
          },
        }),
      })
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
